/// <amd-module name="Build/Admin/PoolsList/Actions/ActionsHub" />
import { Action } from "VSS/Reflux/Action";

import { TaskAgentPool, TaskAgentPoolStatus, TaskAgentQueue } from "DistributedTask/Client/Contracts/TaskAgent";

import { AgentActions } from "Build/Admin/Common/Actions/AgentActions";
import { AgentCloudActions } from "Build/Admin/Common/Actions/AgentCloudActions";
import { ConfirmationDialogActions } from "Build/Admin/Common/Actions/ConfirmationDialogActions";
import { JobActions } from "Build/Admin/Common/Actions/JobActions";
import { NotificationActions } from "Build/Admin/Common/Actions/NotificationActions";
import { ProjectActions } from "Build/Admin/Common/Actions/ProjectActions";
import { ResourceLimitActions } from "Build/Admin/Common/Actions/ResourceLimitActions";
import { ServiceEndpointActions } from "Build/Admin/Common/Actions/ServiceEndpointActions";
import { SignalRActions } from "Build/Admin/Common/Actions/SignalRActions";
import { PoolType } from "Build/Admin/Common/Client/Contracts/DistributedTask/DataProvider";
import { TaskAgentQueueWrapper } from "Build/Admin/Common/Client/Contracts/DistributedTask/Wrappers";

export class ActionsHub {
    public agentActions = new AgentActions();
    public agentCloudActions = new AgentCloudActions();
    public confirmationDialogActions = new ConfirmationDialogActions<TaskAgentQueue | TaskAgentPool>();
    public jobActions = new JobActions();
    public notificationActions = new NotificationActions();
    public projectActions = new ProjectActions();
    public resourceLimitActions = new ResourceLimitActions();
    public serviceEndpointActions = new ServiceEndpointActions();
    public signalRActions = new SignalRActions();

    public agentPoolsUpdated = new Action<TaskAgentPool[]>();
    public agentPoolAdded = new Action<TaskAgentPool>();
    public agentPoolDeleted = new Action<TaskAgentPool>();
    public agentPoolStatusUpdated = new Action<ITaskAgentPoolStatusUpdatePayload>();
    public agentPoolStatusesUpdated = new Action<TaskAgentPoolStatus[]>();
    public agentQueuesUpdated = new Action<TaskAgentQueueWrapper[]>();
    public agentQueueAdded = new Action<TaskAgentQueue>();
    public agentQueueDeleted = new Action<TaskAgentQueue>();
    public dismissCreatePoolPanel = new Action<void>();
    public showCreatePoolPanel = new Action<void>();
    public availablePoolTypesUpdated = new Action<PoolType[]>();
    public dismissSecurityPanel = new Action<void>();
    public showSecurityPanel = new Action<void>();
    public manageAllPermissionUpdated = new Action<boolean>();
}

export interface ITaskAgentPoolStatusUpdatePayload {
    poolId: number;
    status: TaskAgentPoolStatus;
}
